import { BusinessPartner } from '@work4all/models/lib/Classes/BusinessPartner.entity';
import { Contact } from '@work4all/models/lib/Classes/Contact.entity';
import { Customer } from '@work4all/models/lib/Classes/Customer.entity';
import { Document } from '@work4all/models/lib/Classes/Document.entity';
import { Project } from '@work4all/models/lib/Classes/Project.entity';
import { ProjectProcess } from '@work4all/models/lib/Classes/ProjectProcess.entity';
import { Supplier } from '@work4all/models/lib/Classes/Supplier.entity';
import { TopicSimple } from '@work4all/models/lib/Classes/TopicSimple.entity';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';

import { YELLOW_NOTE_FIELDS_QUERY } from '../../../../containers/files/detail/components/yellow-note/yellow-note-fields';

const CUSTOMER_AND_SUPPLIER_ENTITY_RECORD_MATCHER_FIELDS: Omit<
  Customer<EMode.query> | Supplier<EMode.query>,
  '_props'
> = {
  id: null,
  name: null,
  mainContact: {
    id: null,
    eMail: null,
    name: null,
    firstName: null,
    displayName: null,
    layedOff: null,
    role: null,
    salutation: {
      id: null,
      isMale: null,
      isFemale: null,
      standardletterSalutation: null,
    },
  },
  eMail: null,
  eMail2: null,
  isPrivateCustomer: null,
  languageId: null,
  street: null,
  postalCode: null,
  city: null,
  postIt: YELLOW_NOTE_FIELDS_QUERY,
};

export const BUSINESS_PARTNER_ENTITY_RECORD_MATCHER_FIELDS: BusinessPartner<EMode.query> =
  {
    id: null,
    businessPartnerType: null,
    data: {
      customer: CUSTOMER_AND_SUPPLIER_ENTITY_RECORD_MATCHER_FIELDS,
      supplier: CUSTOMER_AND_SUPPLIER_ENTITY_RECORD_MATCHER_FIELDS,
    },
  };

export const PROJECT_ENTITY_RECORD_MATCHER_FIELDS: Project<EMode.query> = {
  id: null,
  name: null,
  customer: CUSTOMER_AND_SUPPLIER_ENTITY_RECORD_MATCHER_FIELDS,
  supplier: CUSTOMER_AND_SUPPLIER_ENTITY_RECORD_MATCHER_FIELDS,
  projectSubDirectories: [{ id: null, name: null }],
};

export const CONTACT_ENTITY_RECORD_MATCHER_FIELDS: Contact<EMode.query> = {
  id: null,
  eMail: null,
  name: null,
  firstName: null,
  displayName: null,
  layedOff: null,
  role: null,
  salutation: {
    id: null,
    isMale: null,
    isFemale: null,
    standardletterSalutation: null,
  },
  businessPartnerType: null,
  businessPartner: {
    id: null,
    data: {
      customer: CUSTOMER_AND_SUPPLIER_ENTITY_RECORD_MATCHER_FIELDS,
      supplier: CUSTOMER_AND_SUPPLIER_ENTITY_RECORD_MATCHER_FIELDS,
    },
  },
};

export const PROJECT_PROCESS_ENTITY_RECORD_MATCHER_FIELDS: ProjectProcess<EMode.query> =
  {
    id: null,
    process: null,
    projectId: null,
  };

export const TOPIC_SIMPLE_ENTITY_RECORD_MATCHER_FIELDS: TopicSimple<EMode.query> =
  {
    id: null,
    name: null,
  };

export const CHILD_DOCUMENTS_ENTITY_RECORD_MATCHER_FIELDS: Document<EMode.query> =
  {
    id: null,
  };
